import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import Seo from "../lib/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { blogPosts } from "../lib/blogPosts";

export default function Blog() {
    return (
        <>
            <Seo
                title="Blog sobre rehabilitación de drogas en Chile"
                description="Artículos editoriales sobre cómo elegir centros de rehabilitación, tipos de tratamiento, precios y señales de alerta. Información clínica y verificada."
                path="/blog"
                keywords="blog rehabilitación, artículos adicciones, cómo elegir centro de rehabilitación, tratamiento drogas"
            />

            <section className="border-b border-slate-800 bg-slate-950">
                <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
                    <Breadcrumbs
                        items={[
                            { name: "Inicio", path: "/" },
                            { name: "Blog" },
                        ]}
                    />
                    <h1 className="mt-5 text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl">
                        Blog sobre rehabilitación y adicciones
                    </h1>
                    <p className="mt-3 max-w-2xl text-slate-400">
                        Guías clínicas, comparativas y recursos editoriales para
                        pacientes, familias y profesionales de la salud en Chile.
                    </p>
                </div>
            </section>

            <section className="py-12">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div
                        className="grid gap-6 md:grid-cols-2 lg:grid-cols-3"
                        data-testid="blog-grid"
                    >
                        {blogPosts.map((post) => (
                            <Link
                                key={post.slug}
                                to={`/blog/${post.slug}`}
                                data-testid={`blog-post-${post.slug}`}
                                className="card-hover group flex flex-col overflow-hidden rounded-xl border border-slate-800 bg-slate-900"
                            >
                                <div className="relative aspect-[16/9] overflow-hidden bg-slate-800">
                                    <img
                                        src={post.image}
                                        alt={post.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                </div>
                                <div className="flex flex-1 flex-col p-5">
                                    <div className="mb-3 flex items-center gap-3 text-xs text-slate-500">
                                        <span>
                                            {new Date(post.datePublished).toLocaleDateString(
                                                "es-CL",
                                                { day: "numeric", month: "long", year: "numeric" },
                                            )}
                                        </span>
                                        <span className="inline-flex items-center gap-1">
                                            <Clock className="h-3 w-3" /> {post.readingMinutes} min
                                        </span>
                                    </div>
                                    <h2 className="text-lg font-semibold text-slate-50 group-hover:text-cyan-400">
                                        {post.title}
                                    </h2>
                                    <p className="mt-2 flex-1 text-sm text-slate-400 line-clamp-3">
                                        {post.description}
                                    </p>
                                    <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-cyan-400">
                                        Leer artículo{" "}
                                        <ArrowRight className="h-3.5 w-3.5" />
                                    </span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
